import { render, staticRenderFns } from "./table.vue?vue&type=template&id=2ea1cffa"
import script from "./table.vue?vue&type=script&lang=js"
export * from "./table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ea1cffa')) {
      api.createRecord('2ea1cffa', component.options)
    } else {
      api.reload('2ea1cffa', component.options)
    }
    module.hot.accept("./table.vue?vue&type=template&id=2ea1cffa", function () {
      api.rerender('2ea1cffa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/do-not-contact/table.vue"
export default component.exports